<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_acc.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="main-title">
          出金アカウントの紐づけ方法
        </h1>
        <h2 class="subheading fs_6">
          <ul class="method-items">
            <li><a class="links anchorTo" @click="scrollTo('getWay_1')">銀行振込で入金する方法 </a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_3')">USDT TRC20で入金する方法</a></li>
            <li><a class="links anchorTo" @click="scrollTo('getWay_4')">USDT ERC20で入金する方法</a></li>
          </ul>
        </h2>
        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_1" class="main-title">
          銀行キャッシュカードで出金方法を紐づけする
        </h2>
        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': toggleStates.getWay1}" @click="toggleState('getWay1')">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !toggleStates.getWay1}" @click="toggleState('getWay1')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <div class="tab-contents" :class="{'is-contents-active': toggleStates.getWay1}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_02.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                1. 紐づけする銀行キャッシュカードを選択
              </p>
              <p class="text_center h2-type">
                2. 銀行を選択
              </p>
              <p class="text_center h2-type">
                3. 支店名を入力
              </p>
              <p class="text_center h2-type">
                4. 支店コードを入力
              </p>
              <p class="text_center h2-type">
                5. 名義人を入力(カタカナ)
              </p>
              <p class="text_center h2-type">
                6. キャッシュカードの番号を力
              </p>
              <p class="text_center h2-type">
                7. もう一度キャッシュカードの番号を入力
              </p>
              <p class="text_center h2-type">
                8. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_03.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !toggleStates.getWay1}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_02.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                1. 紐づけする銀行キャッシュカードを選択
              </p>
              <p class="text_center h2-type">
                2. 銀行を選択
              </p>
              <p class="text_center h2-type">
                3. 支店名を入力
              </p>
              <p class="text_center h2-type">
                4. 支店コードを入力
              </p>
              <p class="text_center h2-type">
                5. 名義人を入力(カタカナ)
              </p>
              <p class="text_center h2-type">
                6. キャッシュカードの番号を力
              </p>
              <p class="text_center h2-type">
                7. もう一度キャッシュカードの番号を入力
              </p>
              <p class="text_center h2-type">
                8. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_03.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_3" class="main-title mt_5r">
          USDT TRC20で出金方法を紐づけする
        </h2>
        <div class="tab-frame">
          <!-- タブを構成するブロック -->
          <ul class="tab-list">
            <li class="tab-list-item-group-3" :class="{'is-btn-active': toggleStates.getWay3}" @click="toggleState('getWay3')">
              PC版
            </li>
            <li class="tab-list-item-group-3" :class="{'is-btn-active': !toggleStates.getWay3}" @click="toggleState('getWay3')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-3" :class="{'is-contents-active': toggleStates.getWay3}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_02.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                1. 暗号通貨を選択
              </p>
              <p class="text_center h2-type">
                2. USDT TRC20を選択
              </p>
              <p class="text_center h2-type">
                3. USDT TRC20のアドレスと登録氏名を入力
              </p>
              <p class="text_center h2-type">
                4. USDT TRC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                5. 再度USDT TRC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                6. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_05.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-3" :class="{'is-contents-active': !toggleStates.getWay3}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_02.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <p class="text_center h2-type">
                1. 暗号通貨を選択
              </p>
              <p class="text_center h2-type">
                2. USDT TRC20を選択
              </p>
              <p class="text_center h2-type">
                3. USDT TRC20のアドレスと登録氏名を入力
              </p>
              <p class="text_center h2-type">
                4. USDT TRC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                5. 再度USDT TRC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                6. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_05.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line hr_my_3rem">

        <h2 id="getWay_4" class="main-title mt_5r">
          USDT ERC20で出金方法を紐づけする
        </h2>
        <div class="tab-frame">
          <!-- タブを構成するブロック -->
          <ul class="tab-list">
            <li class="tab-list-item-group-4" :class="{'is-btn-active': toggleStates.getWay4}" @click="toggleState('getWay4')">
              PC版
            </li>
            <li class="tab-list-item-group-4" :class="{'is-btn-active': !toggleStates.getWay4}" @click="toggleState('getWay4')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-4" :class="{'is-contents-active': toggleStates.getWay4}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_02.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <p class="text_center h2-type">
                1. 暗号通貨を選択
              </p>
              <p class="text_center h2-type">
                2. USDT ERC20を選択
              </p>
              <p class="text_center h2-type">
                3. USDT ERC20のアドレスと登録氏名を入力
              </p>
              <p class="text_center h2-type">
                4. USDT ERC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                5. 再度USDT ERC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                6. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/binding_pc_tab_06.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-4" :class="{'is-contents-active': !toggleStates.getWay4}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウン
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_01.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <p class="text_center h2-type">
                支払い設定をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_02.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <p class="text_center h2-type">
                1. 暗号通貨を選択
              </p>
              <p class="text_center h2-type">
                2. USDT ERC20を選択
              </p>
              <p class="text_center h2-type">
                3. USDT ERC20のアドレスと登録氏名を入力
              </p>
              <p class="text_center h2-type">
                4. USDT ERC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                5. 再度USDT ERC20のウォレットアドレスを入力
              </p>
              <p class="text_center h2-type">
                6. 「確認」をクリック
              </p>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/binding_mb_tab_06.png')" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      toggleStates: {
        getWay1: true,
        getWay2: true,
        getWay3: true,
        getWay4: true
      }
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'account-binding',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleState(key) {
      if (this.toggleStates.hasOwnProperty(key)) {
        this.toggleStates[key] = !this.toggleStates[key]
      }
    },
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
